var _circle, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectWizardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 197,
    viewBox: "0 0 215 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 98.0024,
    r: 98,
    fill: "#D8D8D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_572_255)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 101.002,
    width: 59,
    height: 90,
    rx: 7,
    fill: "#FAFAFA",
    stroke: "#DDDDDD",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 109.002,
    width: 46,
    height: 20,
    rx: 3,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 136.002,
    width: 46,
    height: 20,
    rx: 3,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 163.002,
    width: 46,
    height: 20,
    rx: 3,
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5156 82.7598L38.25 80.7285V75.377C38.25 75.0645 37.9375 74.752 37.625 74.752H35.125C34.7734 74.752 34.5 75.0645 34.5 75.377V77.4082L30.5156 73.9316C30.2812 73.6973 29.8125 73.502 29.5 73.502C29.1484 73.502 28.6797 73.6973 28.4453 73.9316L18.4453 82.7598C18.3281 82.8379 18.2109 83.0723 18.2109 83.2285C18.2109 83.3457 18.2891 83.541 18.4062 83.6191L19.2266 84.5566C19.3438 84.6738 19.5391 84.752 19.6953 84.752C19.8125 84.752 20.0078 84.6738 20.125 84.5957L20.75 84.0488V92.252C20.75 92.9551 21.2969 93.502 22 93.502H37C37.6641 93.502 38.25 92.9551 38.25 92.252V84.0488L38.8359 84.5957C38.9531 84.6738 39.1484 84.752 39.2656 84.752C39.4219 84.752 39.6172 84.6738 39.7344 84.5566L40.5547 83.6191C40.6328 83.541 40.7109 83.3457 40.75 83.2285C40.7109 83.0723 40.6328 82.8379 40.5156 82.7598ZM32 85.1816C31.9609 85.6504 31.6094 86.002 31.1406 86.002H27.8203C27.3516 86.002 27 85.6504 27 85.1816V81.8613C27 81.3926 27.3516 81.041 27.8203 81.002H31.1406C31.6094 81.041 31.9609 81.3926 32 81.8613V85.1816Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.828 78.0723L109.203 73.6582C109.008 73.5801 108.695 73.541 108.5 73.502C108.266 73.541 107.953 73.5801 107.758 73.6582L97.1328 78.0723C96.5078 78.3457 96 79.127 96 79.8301V92.877C96 93.2285 96.2734 93.502 96.625 93.502H99.125C99.4375 93.502 99.75 93.2285 99.75 92.877V82.252C99.75 81.5879 100.297 81.002 101 81.002H115.961C116.664 81.002 117.25 81.5879 117.25 82.252V92.877C117.25 93.2285 117.523 93.502 117.875 93.502H120.375C120.688 93.502 121 93.2285 121 92.877V79.8301C120.961 79.127 120.453 78.3457 119.828 78.0723ZM114.164 87.4082L113.539 84.9473C113.266 83.8145 112.094 82.877 110.922 82.877H106.039C104.867 82.877 103.695 83.8145 103.422 84.9473L102.797 87.4082C102.133 87.6426 101.625 88.4238 101.625 89.127V90.377C101.625 90.8457 101.859 91.2363 102.25 91.4707V92.5645C102.25 93.1113 102.641 93.502 103.188 93.502H104.438C104.945 93.502 105.375 93.1113 105.375 92.5645V91.627H111.625V92.5645C111.625 93.1113 112.016 93.502 112.562 93.502H113.812C114.32 93.502 114.75 93.1113 114.75 92.5645V91.4707C115.102 91.2363 115.375 90.8457 115.375 90.377V89.127C115.336 88.4238 114.828 87.6426 114.164 87.4082ZM105.219 85.416C105.336 85.0645 105.688 84.752 106.039 84.752H110.922C111.273 84.752 111.625 85.0645 111.742 85.416L112.211 87.252H104.75L105.219 85.416ZM104.125 90.377C103.539 90.377 103.188 90.0254 103.188 89.4395C103.188 88.8926 103.539 88.502 104.125 88.502C104.672 88.502 105.531 89.3613 105.531 89.9082C105.531 90.4941 104.672 90.377 104.125 90.377ZM112.875 90.377C112.289 90.377 111.469 90.4941 111.469 89.9082C111.469 89.3613 112.289 88.502 112.875 88.502C113.422 88.502 113.812 88.8926 113.812 89.4395C113.812 90.0254 113.422 90.377 112.875 90.377Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.375 89.752H196.75C195.695 89.752 194.953 89.4395 194.523 89.0879C194.211 88.7363 193.781 88.502 193.312 88.502H192.648C192.18 88.502 191.75 88.7363 191.438 89.0879C191.008 89.4395 190.266 89.752 189.25 89.752C188.195 89.752 187.453 89.4395 187.023 89.0879C186.711 88.7363 186.281 88.502 185.812 88.502H185.148C184.68 88.502 184.25 88.7363 183.938 89.0879C183.508 89.4395 182.766 89.752 181.75 89.752C180.695 89.752 179.953 89.4395 179.523 89.0879C179.211 88.7363 178.781 88.502 178.312 88.502H177.648C177.18 88.502 176.75 88.7363 176.438 89.0879C176.008 89.4395 175.266 89.752 174.25 89.752H173.625C173.273 89.752 173 90.0645 173 90.377V91.627C173 91.9785 173.273 92.252 173.625 92.252H174.25C175.734 92.252 177.062 91.7832 178 91.041C178.898 91.7832 180.227 92.252 181.75 92.252C183.234 92.252 184.562 91.7832 185.5 91.041C186.398 91.7832 187.727 92.252 189.25 92.252C190.734 92.252 192.062 91.7832 193 91.041C193.898 91.7832 195.227 92.252 196.75 92.252H197.375C197.688 92.252 198 91.9785 198 91.627V90.377C198 90.0645 197.688 89.752 197.375 89.752ZM181.75 88.502V84.752H189.25V88.502C189.992 88.502 190.422 88.2676 190.578 88.1504C190.93 87.8379 191.32 87.6035 191.75 87.4473V78.502C191.75 77.8379 192.297 77.252 193 77.252C193.664 77.252 194.25 77.8379 194.25 78.502V79.127C194.25 79.4785 194.523 79.752 194.875 79.752H196.125C196.438 79.752 196.75 79.4785 196.75 79.127V78.502C196.75 76.4707 195.031 74.752 193 74.752C190.93 74.752 189.25 76.4707 189.25 78.502V82.252H181.75V78.502C181.75 77.8379 182.297 77.252 183 77.252C183.664 77.252 184.25 77.8379 184.25 78.502V79.127C184.25 79.4785 184.523 79.752 184.875 79.752H186.125C186.438 79.752 186.75 79.4785 186.75 79.127V78.502C186.75 76.4707 185.031 74.752 183 74.752C180.93 74.752 179.25 76.4707 179.25 78.502V87.4473C179.641 87.6035 180.031 87.8379 180.383 88.1504C180.539 88.2676 180.969 88.502 181.75 88.502Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 101.002,
    width: 59,
    height: 90,
    rx: 7,
    fill: "#FAFAFA",
    stroke: "#DDDDDD",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 163.002,
    width: 46,
    height: 20,
    rx: 3,
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 109.002,
    width: 46,
    height: 20,
    rx: 3,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 136.002,
    width: 46,
    height: 20,
    rx: 3,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 101.002,
    width: 59,
    height: 90,
    rx: 7,
    fill: "#FAFAFA",
    stroke: "#DDDDDD",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 163.002,
    width: 46,
    height: 20,
    rx: 3,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 109.002,
    width: 46,
    height: 20,
    rx: 3,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 136.002,
    width: 46,
    height: 20,
    rx: 3,
    fill: "#C5C5C5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.075 42.4061L109.366 40.9883L107.949 40.2794L109.366 39.5704L110.075 38.1526L110.784 39.5704L112.202 40.2794L110.784 40.9883L110.075 42.4061ZM116.455 45.2417L115.304 42.8934L112.911 41.6972L115.304 40.5452L116.455 38.1526L117.652 40.5452L120 41.6972L117.652 42.8934L116.455 45.2417ZM100.86 50.9129L102.056 53.3055L104.404 54.4574L102.056 55.6537L100.86 58.002L99.7076 55.6537L97.3151 54.4574L99.7076 53.3055L100.86 50.9129ZM97.7581 42.3618L101.524 38.5957C101.79 38.3299 102.144 38.1526 102.499 38.1526C102.898 38.1526 103.252 38.3299 103.518 38.5957L119.601 54.679C120.177 55.2549 120.177 56.1411 119.601 56.6728L115.835 60.4388C115.569 60.7046 115.215 60.8376 114.86 60.8376C114.462 60.8376 114.107 60.7046 113.841 60.4388L97.7581 44.3555C97.1821 43.7796 97.1821 42.8934 97.7581 42.3618ZM104.094 47.1912L106.354 44.9315L102.499 41.0769L100.239 43.3365L104.094 47.1912Z",
    fill: "#3A3A3A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_572_255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 118,
    fill: "white",
    transform: "translate(0 73.002)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectWizardIcon);
export default __webpack_public_path__ + "static/media/project_wizard_icon.28f50ada.svg";
export { ForwardRef as ReactComponent };